import Extend from 'flarum/common/extenders';
import Forum from 'flarum/common/models/Forum';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import File from './models/File';
import Form from './models/Form';
import Submission from './models/Submission';

const extend = [
    new Extend.Store()
        .add('formulaire-files', File)
        .add('formulaire-forms', Form)
        .add('formulaire-submissions', Submission),
    new Extend.Model(Forum)
        .attribute('formulaireCanManage')
        .hasMany('formulaireSignUpForms')
        .hasMany('formulaireComposerForms'),
    new Extend.Model(Discussion)
        .hasMany('formulaireForms')
        .hasMany('formulaireSubmissions'),
    new Extend.Model(User)
        .hasMany('formulaireForms')
        .hasMany('formulaireSubmissions'),
];

export default extend;
